import { Link } from "react-router-dom";
import "./car-service.css";
import { Helmet } from "react-helmet";

export default function Services() {
function soon (){
  alert("Contact to our team using chatbot!");
}
  return (
    <>
<Helmet>
  <title>
    Car Repair & Maintenance Services in Palwal | AutoCare
  </title>

  <meta
    name="description"
    content="Explore professional car repair and maintenance services in Palwal by AutoCare. From periodic maintenance, engine repair, brake service, car detailing to accidental repairs for all brands."
  />

  <link
    rel="canonical"
    href="https://car-repair-mechanic-palwal.netlify.app/services"
  />
</Helmet>

    <div className="servicesPage">
      <h1 className="servicesTitle">Best car services center</h1>
<p className="servicesSubtitle">
  Looking for reliable car repair services near you? AutoCare offers professional AC car service, periodic car maintenance, engine oil & filter change, general car check-up, battery replacement, tyre inspection, denting & painting and bumper repair services in Palwal for all car brands at affordable prices.
</p>


      {/* PERIODIC MAINTENANCE */}
      <div className="serviceSection">
        <h2>Periodic Maintenance Services</h2>
        <div className="serviceGrid">



          <div className="service-card">
  <img
    src="/carServiceImages/periodicServiceMaintainance.webp"
    alt="Periodic Maintenance Service"
    className="service-image"
  />

  <div className="service-content">
    <h3>Periodic Maintenance Service</h3>

<p>
  Keep your car running smoothly with our professional periodic car maintenance service in Palwal, including engine oil change, oil filter replacement, brake inspection, fluid top-up and complete vehicle health check for all car brands.
</p>


    <Link to="/services/periodic-maintenance" className="service-link">
      View Details →
    </Link>
  </div>
</div>
{/* ///////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/engineoil.webp"
              alt="Engine Oil & Filter Change"
              className="service-image"
            />
            <div className="service-content">
            <h3>Engine Oil & Filter Change</h3>
     <p>
  Maintain your car’s engine health with our professional engine oil and filter change service in Palwal, ensuring smooth performance, better mileage and long-lasting engine protection.
</p>

            
            <Link to="/services/engine-oil-filter-change" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////// */}


          <div className="service-card">
            <img
              src="/carServiceImages/genralcarcheckup.webp"
              alt="General Car Check-up"
              className="service-image"
            />
            <div className="service-content">
            <h3>General Car Check-up</h3>
 <p>
  Ensure your car runs smoothly and safely with our comprehensive general car check-up service in Palwal, including brakes, suspension, battery, fluids and complete vehicle inspection by expert technicians.
</p>

            <Link to="/services/general-checkup" className="service-link">View Details →</Link>
          </div>
          </div>

          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/carbattery.webp"
              alt="Battery Check & Replacement"
              className="service-image"
            />
            <div className="service-content">
            <h3>Battery Check & Replacement</h3>
  <p>
  Keep your car powered reliably with our professional battery check and replacement service in Palwal, ensuring quick starts, longer battery life and hassle-free performance for all car brands.
</p>

            <Link to="/services/battery" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/tyreservices.webp"
              alt="Tyre Inspection & Rotation"
              className="service-image"
            />
            <div className="service-content">
            <h3>Tyre Inspection & Rotation</h3>
<p>
  Improve road safety and extend tyre life with our professional tyre inspection and rotation service in Palwal, ensuring even tyre wear, better grip and smoother driving performance.
</p>

            <Link to="/services/tyre" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          </div>
      </div>




      {/* BODY & ACCIDENTAL */}
      <div className="serviceSection">
        <h2>Body & Accidental Repairs</h2>
        <div className="serviceGrid">

        <div className="service-card">
          <img
            src="/carServiceImages/dentingpainting.webp"
            alt="Denting & Painting"
            className="service-image"
          />
          <div className="service-content">
            <h3>Denting & Painting</h3>
<p>
  Restore your car’s original look with our professional denting and painting service in Palwal, delivering a flawless finish, color matching and long-lasting paint protection.
</p>

            <Link to="/services/denting-painting" className="service-link">View Details →</Link>
          </div>
        </div>

          <div className="service-card">
            <img
              src="/carServiceImages/bumperrepair.webp" 
              alt="Bumper Repair"
              className="service-image"
            />
            <div className="service-content">
              <h3>Bumper Repair</h3>
   <p>
  Get professional car bumper repair service in Palwal to restore safety and your vehicle’s original look, including crack repair, alignment fixing and paint finishing.
</p>

              <Link to="/services/bumper-repair" className="service-link">View Details →</Link>
            </div>
          </div>

          <div className="service-card">
            <img
              src="/carServiceImages/accidentalrepair.webp"

              alt="Accidental Repair"
              className="service-image" 
            />
            <div className="service-content">
              <h3>Accidental Repair</h3>
<p>
  Get comprehensive accidental car repair service in Palwal to restore your vehicle’s safety and appearance after an accident, including body repair, denting, painting and alignment work.
</p>

              <Link to="/services/accidental-repair" className="service-link">View Details →</Link>
            </div>
          </div>

          <div className="service-card">
            <img
              src="/carServiceImages/scratchremoval.webp"
              alt="Scratch Removal"
              className="service-image"
            />
            <div className="service-content">
              <h3>Scratch Removal</h3>
<p>
  Get professional car scratch removal service in Palwal to restore your vehicle’s paintwork, remove minor and deep scratches, and enhance its overall appearance.
</p>

              <Link to="/services/scratch-removal" className="service-link">View Details →</Link>
            </div>
          </div>

          <div className="service-card">
            <img
              src="/carServiceImages/panelreplacement.webp"
              alt="Panel Replacement"
              className="service-image"
            />
            <div className="service-content">
              <h3>Panel Replacement</h3>
<p>
  Get expert car panel replacement service in Palwal to fix damaged panels and restore your vehicle’s structural strength, safety and original appearance.
</p>

              <Link to="/services/panel-replacement" className="service-link">View Details →</Link>
            </div>
          </div>
        </div>
      </div>

      {/* DETAILING */}
      <div className="serviceSection">
        <h2>Car Detailing & Protection</h2>
        <div className="serviceGrid">


          <div className="service-card">
            <img
              src="/carServiceImages/ceramiccoating.webp"
              alt="9H Ceramic Coating"
              className="service-image"
            />
            <div className="service-content">
            <h3>9H Ceramic Coating</h3>
<p>
  Protect your car’s paint with our advanced 9H ceramic coating service in Palwal, delivering long-lasting shine, superior gloss and durable paint protection for all car brands.
</p>

            <Link to="/services/ceramic-coating" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div className="service-card">
            <img

              src="/carServiceImages/rubbingpolishing.webp"
              alt="Rubbing & Polishing"
              className="service-image"
            />
            <div className="service-content">
            <h3>Rubbing & Polishing</h3>
<p>
  Restore your car’s shine with our professional rubbing and polishing service in Palwal, removing minor scratches, swirl marks and imperfections while enhancing gloss and paint finish.
</p>

            <Link to="/services/rubbing-polishing" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/waxing.webp"
              alt="Waxing"
              className="service-image"
            />
            <div className="service-content">
            <h3>Waxing</h3>
<p>
  Give your car a protective layer and deep glossy finish with our professional car waxing service in Palwal, helping protect paint from dust, UV rays and environmental damage.
</p>

            <Link to="/services/waxing" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div className="service-card">
            <img
              src="/carServiceImages/paintenhancement.webp"
              alt="Paint Enhancement"
              className="service-image"
            />
            <div className="service-content">
            <h3>Paint Enhancement</h3>
   <p>
  Enhance and restore your car’s paint with our professional paint enhancement service in Palwal, improving color depth, removing minor imperfections and delivering a like-new finish.
</p>

            <Link to="/services/paint-enhancement" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div className="service-card">
            <img
              src="/carServiceImages/windshieldcoating.webp"
              alt="Windshield Coating"
              className="service-image"
            />
            <div className="service-content">
            <h3>Windshield Coating</h3>
            <p>
              Protect your windshield with our professional coating service for improved visibility and durability.
            </p>
            <Link to="/services/windshield-coating" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
        </div>
      </div>

      {/* CLEANING */}
      <div className="serviceSection">
        <h2>Cleaning Services</h2>
        <div className="serviceGrid">

          <div className="service-card">
            <img
              src="/carServiceImages/deep Interior Cleaning.webp"
              alt="Deep Interior Cleaning"
              className="service-image"
            />
            <div className="service-content">
            <h3>Deep Interior Cleaning</h3>
            <p>
              Revitalize your car's interior with our thorough deep cleaning service for a fresh and hygienic environment.
            </p>
            <Link to="/services/interior-cleaning" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/Exterior Cleaning.webp"
              alt="Exterior Cleaning"
              className="service-image"
            />
            <div className="service-content">
            <h3>Exterior Cleaning</h3>
            <p>
              Clean and shine your car's exterior with our professional exterior cleaning service.
            </p>
            <Link to="/services/exterior-cleaning" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/EngineBayCleaning.webp"
              alt="Engine Bay Cleaning"
              className="service-image"
            />
            <div className="service-content">
            <h3>Engine Bay Cleaning</h3>
 <p>
  Get professional engine bay cleaning service in Palwal to remove dirt and grease, improve engine appearance and help maintain optimal performance.
</p>

            <Link to="/services/engine-cleaning" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img
              src="/carServiceImages/DashboardPolishing.webp"
              alt="Dashboard Polishing"
              className="service-image"
            />
            <div className="service-content">
            <h3>Dashboard Polishing</h3>
  <p>
  Restore and maintain your car dashboard’s appearance with our professional dashboard polishing service in Palwal, protecting against dust, scratches and UV damage.
</p>

            <Link to="/services/dashboard-polish" className="service-link">View Details →</Link>
          </div>
          </div>

        </div>
      </div>

      {/* MECHANICAL & COMMON REPAIRS */}
      <div className="serviceSection">
        <h2>Mechanical & Common Repairs</h2>
        <div className="serviceGrid">

          <div className="service-card">
            <img

              src="/carServiceImages/enginerepair.webp"
              alt="Engine Repair"
              className="service-image"
            />
            <div className="service-content">
            <h3>Engine Repair</h3>
<p>
  Get expert car engine repair service in Palwal to restore your vehicle’s performance, reliability and engine health, including diagnostics, part replacement and fine-tuning by skilled technicians.
</p>

            <Link to="/services/engine-repair" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div className="service-card">
            <img

              src="/carServiceImages/brake repair.webp"
              alt="Brake Repair"
              className="service-image"
            />
            <div className="service-content">
            <h3>Brake Repair</h3>
<p>
  Get professional car brake repair service in Palwal to ensure your vehicle’s safety, optimal stopping power and reliable performance, including pad replacement, fluid check and brake system inspection.
</p>

            <Link to="/services/brake-repair" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          <div className="service-card">
            <img

              src="/carServiceImages/suspension Repair.webp"
              alt="Suspension Repair"
              className="service-image"
            />
            <div className="service-content">
            <h3>Suspension Repair</h3>
<p>
  Get reliable car suspension repair service in Palwal to improve ride comfort, handling and vehicle stability, including shock absorber replacement and suspension system inspection by expert technicians.
</p>

            <Link to="/services/suspension" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}

          <div className="service-card">
            <img  
              src="../carServiceImages/transmission.webp"
              alt="Transmission Repair"
              className="service-image"
            />
            <div className="service-content">
            <h3>Transmission Repair</h3>
<p>
  Get expert car transmission repair service in Palwal to restore smooth gear shifting, optimal performance and reliable driving experience, including manual and automatic transmission diagnostics and repairs.
</p>

            <Link to

="/services/transmission-service" className="service-link">View Details →</Link>
          </div>
          </div>
          {/* ////////////////////////////////////////////////////////////////////////////////////////////// */}
          
          <Link to="" onClick={soon}>Clutch Repair</Link>

          <div className="service-card">
            <img
              src="/blogimg/CarACThandiHawaNahiDeRaha.webp"
              alt="AC Repair & Gas Refill"
              className="service-image"
            />
            <div className="service-content">
            <h3>AC Repair & Gas Refill</h3>
<p>
  Keep your car cool and comfortable with our professional AC repair and gas refill service in Palwal, ensuring efficient cooling, improved air quality and reliable performance for all car brands.
</p>

            <Link to="/services/car-ac-repair" className="service-link">View Details →</Link>
          </div>
          </div>

        </div>
      </div>
      <Link to="/contact" className="bookAppointment" style={{alignItems:'center',textAlign:'center'}}>Contact Us for More Services</Link>
    </div>
    </>
  );
}
